import { render, staticRenderFns } from "./dashboardmain.vue?vue&type=template&id=c515924a&scoped=true&"
import script from "./dashboardmain.vue?vue&type=script&lang=js&"
export * from "./dashboardmain.vue?vue&type=script&lang=js&"
import style0 from "./dashboardmain.vue?vue&type=style&index=0&id=c515924a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c515924a",
  null
  
)

export default component.exports